package music.jammers.client.shared.component

actual val widthFraction: Float = 0.5f